import { render, staticRenderFns } from "./ErrorListpage.vue?vue&type=template&id=bc1e14e0&scoped=true&"
import script from "./ErrorListpage.vue?vue&type=script&lang=js&"
export * from "./ErrorListpage.vue?vue&type=script&lang=js&"
import style0 from "./ErrorListpage.vue?vue&type=style&index=0&id=bc1e14e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e14e0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VPagination,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc1e14e0')) {
      api.createRecord('bc1e14e0', component.options)
    } else {
      api.reload('bc1e14e0', component.options)
    }
    module.hot.accept("./ErrorListpage.vue?vue&type=template&id=bc1e14e0&scoped=true&", function () {
      api.rerender('bc1e14e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/pages/ErrorListpage.vue"
export default component.exports